import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Shiitake } from './Shiitake';
import type { ShiitakeProps } from './Shiitake';

const useStyles = makeStyles({ name: 'Clamp' })({
  root: {
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
});

export const Clamp: React.FC<ShiitakeProps> = (({
  lines, className = '', overflowNode, ...restProps
}) => {
  const { classes, cx } = useStyles();

  if (overflowNode) {
    return (
      <Shiitake
        lines={lines}
        className={className}
        overflowNode={overflowNode}
        {...restProps}
      />
    );
  }

  return (
    <Typography
      className={cx(classes.root, className)}
      style={{
        WebkitLineClamp: lines,
        lineClamp: lines,
      }}
      {...restProps}
    />
  );
});
